import {
    NAME_CHANGE,
    LAST_CHANGE,
    PHONE_CHANGE,
    EMAIL_CHANGE,
    POSITION_CHANGE,
    SET_CUSTOMER,
    ERASE_CUSTOMER_CONTACT,
} from './constants';

export const setCustomerContact = customer => ({
    type: SET_CUSTOMER,
    customer,
});
export const eraseCustomerContact = () => ({
    type: ERASE_CUSTOMER_CONTACT,
});
export const setNameChange = firstName => ({
    type: NAME_CHANGE,
    firstName,
});

export const setLastNameChange = lastName => ({
    type: LAST_CHANGE,
    lastName,
});

export const setPhoneChange = phone => ({
    type: PHONE_CHANGE,
    phone,
});

export const setEmailChange = email => ({
    type: EMAIL_CHANGE,
    email,
});

export const setPositionChange = position => ({
    type: POSITION_CHANGE,
    position,
});



// WEBPACK FOOTER //
// ./src/containers/AddClient/Contact/actions.js